var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.baseStyle, !_vm.tile.isClickable && !_vm.inSlot ? _vm.disabledStyle : _vm.clickableStyle],
    style: _vm.positionStyle,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "drop-shadow-sm filter"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/game/sheep/' + _vm.tile.type),
      "alt": ""
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };